import axios from "axios";
import { StorageService } from "@/services/storage.service";
import store from "@/store";

const ApiService = {
  _401interceptor: null,
  _headerInterceptor: null,

  init(baseUrl) {
    axios.defaults.baseURL = baseUrl;
    // axios.defaults.headers.common["X-Pkss-Domain"] = window.location.hostname;
    axios.defaults.headers.common["X-Pkss-Domain"] = "pkssdev.heldenplaner.de";
  },

  setHeader() {
    if (process.env.VUE_APP_AUTHORIZATION_METHOD === "X-API-Key") {
      axios.defaults.headers.common["X-API-Key"] = StorageService.getToken();
    } else {
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${StorageService.getToken()}`;
    }
  },

  removeHeader() {
    axios.defaults.headers.common = {};
    // axios.defaults.headers.common["X-Pkss-Domain"] = window.location.hostname;
    axios.defaults.headers.common["X-Pkss-Domain"] = "pkssdev.heldenplaner.de";
  },

  getResource(resource) {
    const isTrailingSlash = process.env.VUE_APP_TRAILING_SLASH;
    try {
      if (resource.slice(-1) === "/") {
        if (isTrailingSlash === "true") {
          return resource;
        } else {
          return resource.slice(0, resource.length - 1);
        }
      } else {
        if (isTrailingSlash === "true") {
          return resource + "/";
        } else {
          return resource;
        }
      }
    } catch {
      return resource;
    }
  },

  get(resource, config) {
    return axios.get(this.getResource(resource), config);
  },

  post(resource, data, config) {
    return axios.post(this.getResource(resource), data, config);
  },

  put(resource, data, config) {
    return axios.put(this.getResource(resource), data, config);
  },

  delete(resource, config) {
    return axios.delete(this.getResource(resource), config);
  },

  customRequest(data) {
    return axios(data);
  },

  mount401Interceptor() {
    this._401interceptor = axios.interceptors.response.use(
      response => {
        return response;
      },
      async error => {
        if (error.request.status == 401 && error.config.url !== "/auth/login") {
          store.dispatch("auth/logout");
          throw error;
        }

        throw error;
      }
    );
  },

  unmount401Interceptor() {
    axios.interceptors.response.eject(this._401interceptor);
  }
};

export default ApiService;
